<template lang="html">
  <vue-multiselect
    v-model="model"
    select-label=""
    deselect-label=""
    selected-label=""
    :options="options"
    :allow-empty="false"
    :placeholder="placeholder"
    :label="label"
    @select="emit"
  />
</template>

<script>
import VueMultiselect from 'vue-multiselect';

export default {
  components: {
    VueMultiselect,
  },

  props: {
    value: [String, Number, Object],
    options: Array,
    label: String,
    placeholder: {
      type: String,
      default: 'Select option',
    },
  },

  data() {
    return {
      model: this.value,
    };
  },

  watch: {
    value(value) {
      this.model = value;
    },

    model(value) {
      this.$emit('input', value);
    },
  },

  methods: {
    emit(value) {
      this.$emit('select', value);
    },
  },
};
</script>
